import React, { Component } from 'react';
import ConvolverWaveform from './ConvolverWaveform.js';
import Sample from 'repos/Sample.js';
import ipfs from 'decentralized/Ipfs.js';
import Dropdown from 'react-dropdown';
import WetSlider from './WetSlider.js';
import { connect } from "react-redux";
import ParameterKnob from 'components/knobs/ParameterKnob.js';
import {setSampleDragging} from 'actions/index.js';
import ethereum from 'decentralized/ethereum.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';

class ConvolverReverbEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reverbEffect: props.reverbEffect,
        };

        this.getConvolverType();
        this.getConvolverThumbnail();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.reverbEffect !== this.props.reverbEffect) {
            this.state.reverbEffect = nextProps.reverbEffect;
            this.getConvolverType();
            this.getConvolverThumbnail();
        }
        if (nextProps.sample !== this.props.sample) {
            this.getConvolverType();
            this.getConvolverThumbnail();
        }
        return true;
    }

    handleConvolverTypeChange(convolverType) {
        this.state.reverbEffect.setConvolverType(convolverType);
        this.getConvolverType();
        this.getConvolverThumbnail();
        this.setState(this.state);
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.isEnabled;
    }

    async getConvolverThumbnail() {
        let effectNode = this.state.reverbEffect;
        if (effectNode.convolverSample) {
            let sample = new Sample(effectNode.convolverSample);
            await sample.load(false);
            let thumb = sample.getThumbnail();
            if (thumb === undefined || thumb === "") {
                this.setState({thumbnail: undefined});
                return;
            }
            this.setState({
                thumbnail: thumb
            });
        }
    }

    async getConvolverType() {
        let effectNode = this.state.reverbEffect;
        if (effectNode.convolverSample) {
            let name = await ethereum.getTitleForSound(effectNode.convolverSample);
            this.state.convolverType = {label: name, value: effectNode.convolverSample};
            this.setState(this.state);
        } else {
            var options = convolverTypeOptions
                .filter((opt) => opt.value === effectNode.convolverType);
            this.state.convolverType = options[0];
            this.state.thumbnail = undefined;
            this.setState(this.state);
        }
    }

    upload(file) {
        let reader = new FileReader();
        if (!file.name.includes('.wav') && !file.name.includes('.flac') && !file.name.includes('.mp3')) {
            window.alert('Only accepts .wav, .mp3, & .flac files for now');
            return;
        }
        reader.readAsArrayBuffer(file)
        reader.onloadend = async () => {
            let raw = reader.result;
            let convolverHash = await ipfs.addArrayBuffer(raw);
            console.log("CONVOLVER HASH = ", convolverHash);
            await this.props.reverbEffect.setConvolverSample(convolverHash);
            await this.getConvolverType();
            await this.getConvolverThumbnail();
        };
    }

    async onDrop(e) {
        e.stopPropagation();
        e.preventDefault();
        e.dataTransfer.effectAllowed = "none";
        e.dataTransfer.dropEffect = "none";
        
        if (e.dataTransfer.items) {
            let len = e.dataTransfer.items.length;
            for (var i = 0; i < e.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (e.dataTransfer.items[i].kind === 'file') {
                    this.upload(e.dataTransfer.items[i].getAsFile());
                }
            }
        } 

        if (this.props.sampleDragging) {
            e.stopPropagation();
            await this.props.reverbEffect.setConvolverSample(this.props.sampleDragging.getId());
            await this.getConvolverType();
            await this.getConvolverThumbnail();
            this.props.setSampleDragging(undefined);
        }
    }

    render() {
        var wet = this.state.reverbEffect.getWet();
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.state.reverbEffect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        
        return (
            <div
              onDrop={(e) => this.onDrop(e)}
              >
              {!this.isEnabled() ? '' :
                <div>
                  <div className="convolver-type">
                    {this.state.convolverType ? this.state.convolverType.label : ""}
                  </div>
                  <ConditionedComponent condition={this.state.thumbnail}>
                    <img className="convolver-thumbnail" src={this.state.thumbnail}/>
                  </ConditionedComponent>
                  <div className="convolver-row">
                    <ParameterKnob
                      scrollContainer={this.props.scrollContainer}
                      min={-24} max={24} name="Pitch" parameter={this.state.reverbEffect.pitchParameter}/>
                    <ParameterKnob
                      scrollContainer={this.props.scrollContainer}
                      min={0} max={100} name="Start" parameter={this.state.reverbEffect.startParameter}/>
                    <ParameterKnob
                      scrollContainer={this.props.scrollContainer}
                      min={0} max={100} name="Attack" parameter={this.state.reverbEffect.attackParameter}/>
                    <ParameterKnob
                      scrollContainer={this.props.scrollContainer}
                      min={0.5} max={100} name="Release" parameter={this.state.reverbEffect.durationParameter}/>
                 </div>
                        <WetSlider
                        effectNumber={this.props.effectNumber}
                    sequencerEngine={this.props.sequencerEngine}
                              automation={this.props.automation}
                              selectedParameter={this.props.selectedParameter}
                              onParameterChanged={this.props.onParameterChanged}
                              effect={this.state.reverbEffect}/>
                  </div>} 
            </div>
        );
    }
}
const convolverTypeOptions = [
    {value: 'Giant Cave', label: 'Giant Cave'},
    {value: 'Hangar', label: 'Airport Hangar'},
    {value: 'Airport Terminal', label: 'Airport Terminal'},
    {value: 'Outdoor Blastoff', label: 'Outdoor Blastoff'}, 
    {value: 'Outdoor Stadium', label: 'Outdoor Stadium'}, 
    {value: 'Plate Large', label: 'Plate Large'}, 
    {value: 'Plate Medium', label: 'Plate Medium'}, 
    {value: 'Plate Small', label: 'Plate Small'}, 
    {value: 'Plate Super Dry', label: 'Plate Super Dry'}, 
    {value: 'Prime Long', label: 'Prime Long'}, 
    {value: 'Prime Medium', label: 'Prime Medium'}, 
    {value: 'Prime Short', label: 'Prime Short'}, 
    {value: 'Prime Extra Long', label: 'Prime Extra Long'}, 
    {value: 'Room Concert Hall', label: 'Room Concert Hall'}, 
    {value: 'Room Huge', label: 'Room Huge'}, 
    {value: 'Room Large', label: 'Room Large'}, 
    {value: 'Room Medium', label: 'Room Medium'}, 
    {value: 'Room Pool', label: 'Room Pool'}, 
];

const mapDispatchToProps = (dispatch, props) => {
    return {
        setSampleDragging : (sample) => dispatch(setSampleDragging(sample)),
    }
};
 
const mapStateToProps = (state, props) => {
    return {
        sampleDragging: state.selector.sampleDragging,
        isEnabled: props.reverbEffect.enabledParameter.get(),
        sample: props.reverbEffect.convolverSample,
        preset: props.reverbEffect.preset
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvolverReverbEffect);
